import { Button } from '@/shared/components/Button';
import SelectField from '@/shared/components/form/Fields/SelectField';
import Panel from '@/shared/components/Panel';
import {
	colorAccent,
	colorBackground,
	colorGreen,
	colorText,
	colorTextAdditional,
} from '@/utils/palette';
import { useMemo, useState } from 'react';
import styled from 'styled-components';

const NetworkInterfaces = ({
	networkInterfaces,
	isModal = false,
	isSort = false,
}) => {
	const [sortBy, setSortBy] = useState('name');
	const [sortOrder, setSortOrder] = useState('asc');
	const [isFilterOpen, setIsFilterOpen] = useState(false);

	console.log(networkInterfaces);

	const sortedInterfaces = useMemo(() => {
		if (!networkInterfaces || networkInterfaces.length === 0) return [];

		return [...networkInterfaces].sort((a, b) => {
			let aValue = a[sortBy] || '';
			let bValue = b[sortBy] || '';

			if (sortBy === 'ip') {
				aValue = aValue.toString();
				bValue = bValue.toString();
			}

			if (sortOrder === 'asc') {
				return aValue.localeCompare(bValue);
			} else {
				return bValue.localeCompare(aValue);
			}
		});
	}, [networkInterfaces, sortBy, sortOrder]);

	const handleSortChange = newSortBy => {
		if (sortBy === newSortBy) {
			setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
		} else {
			setSortBy(newSortBy);
			setSortOrder('asc');
		}
	};

	return (
		<Panel
			lg={isModal ? 6 : 6}
			xl={isModal ? 6 : 6}
			md={isModal ? 6 : 12}
			sm={isModal ? 6 : 12}
			title="Network Interfaces"
		>
			<div style={{ display: 'block' }}>
				<Button
					variant="primary"
					onClick={() => setIsFilterOpen(!isFilterOpen)}
					style={{ marginBottom: '10px', float: 'right' }}
				>
					Filter
				</Button>
			</div>
			<br />
			<br />
			{isFilterOpen && (
				<SortContainer>
					<SortSection>
						<SortLabel>Sort by:</SortLabel>
						<SelectField
							style={{ textAlign: 'left !important' }}
							name="sortBy"
							options={[
								{ value: 'name', label: 'Name' },
								{ value: 'ip', label: 'IP Address' },
								{ value: 'mac', label: 'MAC Address' },
							]}
							placeholder="Select Sort By"
							onChange={e => handleSortChange(e.value)}
						/>
					</SortSection>
					<SortDirectionSection>
						<SortButton
							onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
							aria-label={`Sort ${sortOrder === 'asc' ? 'descending' : 'ascending'}`}
							$isActive={true}
						>
							{sortOrder === 'asc' ? '↑' : '↓'}
						</SortButton>
					</SortDirectionSection>
				</SortContainer>
			)}

			<NetworkList>
				{sortedInterfaces.map((iface, index) => (
					<NetworkItem key={index}>
						<NetworkHeader>
							<NetworkName>{iface.name}</NetworkName>
							{iface.ip && <NetworkIP>{iface.ip}</NetworkIP>}
						</NetworkHeader>
						<NetworkMAC>{iface.mac}</NetworkMAC>
					</NetworkItem>
				))}
			</NetworkList>
		</Panel>
	);
};

export default NetworkInterfaces;

const SortContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 15px;
	margin: 15px 0;
	padding: 15px;
	background: ${colorBackground};
	border-radius: 8px;
	border: 1px solid ${colorAccent}20;
	// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const SortSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	flex: 1;
`;

const SortDirectionSection = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

const SortLabel = styled.span`
	font-size: 14px;
	color: ${colorText};
	font-weight: 600;
	white-space: nowrap;
	text-align: left;
`;

const SortSelect = styled.select`
	padding: 6px 10px;
	border: 1px solid ${colorAccent}40;
	border-radius: 4px;
	background: white;
	color: ${colorText};
	font-size: 14px;
	cursor: pointer;

	&:focus {
		outline: none;
		border-color: ${colorAccent};
	}
`;

const SortButton = styled.button`
	padding: 8px 12px;
	border: 1px solid ${colorAccent}40;
	border-radius: 6px;
	background: ${props => (props.$isActive ? colorAccent : 'white')};
	color: ${props => (props.$isActive ? 'white' : colorText)};
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	min-width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		// background: ${props => (props.$isActive ? colorAccent : colorAccent)}10;
		border-color: ${colorAccent};
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	&:focus {
		outline: none;
		border-color: ${colorAccent};
		box-shadow: 0 0 0 2px ${colorAccent}20;
	}

	&:active {
		transform: translateY(0);
	}
`;

const NetworkList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
	margin-top: 20px;
`;

const NetworkItem = styled.div`
	padding: 15px;
	background: ${colorBackground};
	border-radius: 8px;
	border-left: 4px solid ${colorAccent};
`;

const NetworkHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 5px;
`;

const NetworkName = styled.span`
	font-weight: 600;
	font-size: 17px;
	color: ${colorText};
`;

const NetworkIP = styled.span`
	font-size: 15px;
	color: ${colorGreen};
	font-weight: 500;
`;

const NetworkMAC = styled.p`
	font-size: 15px;
	color: ${colorTextAdditional};
	text-align: left;
`;
